<template>
    <div>
        <iframe :src="URL" width="100%" height="600px" onload="this.height=this.contentWindow.document.body.scrollHeight;"></iframe>
    </div>
</template>

<script>
import { i18n } from "../main";
export default {
    name: 'analysen_sast',
    data () {
        return {
            URL: '/dbp/'+i18n.locale+'/analysen_sast'
        }
    },
    computed: {
    }
}
</script>